<script>
	// A filter button that opens a list of values to tick (several can be chosen).
	import { createEventDispatcher } from 'svelte';
	import Icon from './Icon.svelte';

	export let label;
	export let options = [];
	export let selected = [];

	const dispatch = createEventDispatcher();
	let open = false;

	function toggle(value) {
		selected = selected.includes(value) ? selected.filter((v) => v !== value) : [...selected, value];
		dispatch('change', selected);
	}

	function clear() {
		selected = [];
		dispatch('change', selected);
		open = false;
	}

	$: allOn = options.length > 0 && options.every((v) => selected.includes(v));

	function toggleAll() {
		selected = allOn ? [] : [...options];
		dispatch('change', selected);
	}
</script>

<div class="wrap">
	<button class="chip" class:active={selected.length} on:click={() => (open = !open)} disabled={!options.length}>
		{label}{#if selected.length}: <b>{selected.length === 1 ? selected[0] : selected.length + ' נבחרו'}</b>{/if}
		<span class="caret">▼</span>
	</button>

	{#if open}
		<div class="catcher" on:click={() => (open = false)} />
		<div class="pop" role="listbox">
			<button class="opt all" class:on={allOn} on:click={toggleAll}>
				<span class="box">{#if allOn}<Icon name="check" size={18} />{/if}</span>
				{allOn ? 'ביטול הסימון' : 'סמן הכל'}
			</button>
			<div class="list">
				{#each options as value}
					<button class="opt" class:on={selected.includes(value)} on:click={() => toggle(value)}>
						<span class="box">{#if selected.includes(value)}<Icon name="check" size={18} />{/if}</span>
						{value}
					</button>
				{/each}
			</div>
			<div class="foot">
				<button class="link-btn" on:click={clear}>ניקוי</button>
				<button class="btn-primary small" on:click={() => (open = false)}>סגירה</button>
			</div>
		</div>
	{/if}
</div>

<style>
	.wrap { position: relative; }
	.catcher { position: fixed; inset: 0; z-index: 24; }
	.pop {
		position: absolute; top: calc(100% + 8px); right: 0; z-index: 25;
		width: 280px; background: var(--surface); border: 1px solid var(--line); border-radius: 16px;
		box-shadow: var(--shadow); overflow: hidden;
	}
	.list { max-height: 360px; overflow: auto; padding: 6px; }
	.opt.all { border-radius: 0; border-bottom: 1px solid var(--line); padding: 0 18px; font-weight: 700; }
	.opt {
		display: flex; align-items: center; gap: 12px; width: 100%;
		min-height: 50px; padding: 0 12px; border: 0; border-radius: 10px; background: none; text-align: start; font-size: 17px;
	}
	.opt:active { background: var(--bg); }
	.opt.on { font-weight: 700; }
	.box {
		width: 26px; height: 26px; border-radius: 7px; border: 2px solid var(--line-strong);
		display: grid; place-items: center; flex: none;
	}
	.opt.on .box { background: var(--ink); border-color: var(--ink); color: #fff; }
	.foot { display: flex; justify-content: space-between; align-items: center; padding: 10px 12px; border-top: 1px solid var(--line); }
</style>
